import React from "react";
import Container from "../../elements/Container";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import Event1 from "../../../assets/img/Events/dorian-hurst-d-igN2ptyC8-unsplash.jpg";
import Event2 from "../../../assets/img/Events/Les-Vieilles-Charrues-2024.webp";
import Event3 from "../../../assets/img/Events/hellfest.jpg";
import Heading from "../../elements/displayTitles/Heading";

import "../../../css/carousel.css";

const Slide = ({ children, src, description }) => {
   return (
      <div className="grid grid-cols-2 gap-x-5 p-6 h-96">
         <div className="p-3 flex flex-col items-start pt-10">
            <Heading variant="h4" theme="secondary" className="border-b-2 border-secondary/70 mb-3">
               événements à venir
            </Heading>
            <Heading theme="title" variant="h3" className="mb-5">
               {children}
            </Heading>
            <p>{description}</p>
         </div>
         <div className="bg-red-custom relative w-full h-full">
            <img
               src={src}
               alt="Description de l'image."
               className="absolute top-0 left-0 h-full w-full object-cover object-bottom"
            />
            photo
         </div>
      </div>
   );
};

export default function Events() {
   // Carousel
   const handleDragStart = (e) => e.preventDefault();

   const items = [
      <Slide
         src={Event1}
         children={"Demi-finale"}
         description="Avenged Sevenfold is an American heavy metal band from Huntington Beach, California, formed in 1999. The band’s name is derived from the biblical passage Genesis 4:24, which states “If Cain is avenged seven times, then Lamech seventy-seven times."
      />,
      <Slide
         src={Event2}
         children={"Vieilles Charrues"}
         description="Les Vieilles Charrues, c’est une structure 100% associative portée par des valeurs fortes de solidarité, de développement durable et d’ancrage territorial.
         Mais c’est aussi et surtout 4 jours hors du temps de fête et de musique, pour tout.e.s !"
      />,
      <Slide
         src={Event3}
         children={"Hellfest 2024"}
         description="Pour sa 17ème édition, le Hellfest se déroulera sur 4 journées avec plus de 200 groupes et artistes issus des musiques extrêmes. Profitez des deux zones pour louer un casier et vivre le festival les mains libres! "
      />,
   ];

   return (
      <Container className="hidden md:block">
         <div className="shadow-2xl w-full mb-10">
            <AliceCarousel
               mouseTracking
               items={items}
               autoPlay={true}
               autoPlayInterval={4000}
               infinite
               disableButtonsControls   
            />
         </div>
      </Container>
   );
}
